"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreventUserSelect = {
    userSelect: 'none',
    'WebkitUserSelect': 'none',
    'msUserSelect': 'none',
    'MozUserSelect': 'none'
};
exports.Elided = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
};
//# sourceMappingURL=CSSMacros.js.map